import { Button, Container, Grid, IconButton, Stack, Typography } from '@mui/material';
import MuiCard from '@mui/material/Card';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import BackButton from '../../components/BackButton';
import Page from '../../components/Page';
import { saveEmailData } from '../../features/campaign/campaignSlice';

const columns = [{ field: 'id' }, { field: 'name', width: 250 }, { field: 'email', width: 250 }, { field: 'phone', width: 250 }];
const Card = (props) => <MuiCard sx={{ p: 2 }} {...props} />;

export default function CampaignDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [campaign, setCampaign] = useState({});

  useEffect(() => {
    try {
      const campaign = JSON.parse(localStorage.getItem('campaign'));
      const rows = JSON.parse(campaign.to);
      setCampaign(campaign);
      setRows(rows.map((e, id) => ({ ...e, id })));
    } catch (error) {
      navigate(-1);
    }
  }, []);

  const handleEdit = () => {
    dispatch(saveEmailData({ ...campaign, to: [], edit: true }));
    navigate('/dashboard/campaigns/campaigns/create');
  };

  const handleExecuteCampaign = () => {
    navigate(
      `/dashboard/campaigns/campaigns/execute?campaignName=${campaign.campain}&templateName=${campaign.template}`
    );
  };

  return (
    <Page title="Campaign Details">
      <Container>
        <BackButton />
        <Stack direction="row" mb={2} justifyContent="space-between" alignItems="center">
          <Typography variant="h3">{campaign.campain}</Typography>
          <Button variant="contained" onClick={handleExecuteCampaign}>
            Execute
          </Button>
        </Stack>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card>
              <Typography>From: {campaign.from}</Typography>
              <Typography>Template: {campaign.template}</Typography>
              <Typography>Created At: {new Date(campaign.createdAt).toDateString()}</Typography>
              <Stack alignItems="end">
                <IconButton sx={{ width: 36 }} onClick={handleEdit}>
                  <EditIcon />
                </IconButton>
              </Stack>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <Typography variant="h4">To</Typography>
              <DataGrid autoHeight columns={columns} rows={rows} />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
